import React, { useEffect } from "react";
import clsx from "clsx";
import { Link } from "react-router-dom";
import Layout from "../layouts";
import { useSpacesStore } from "../store";
import { Tooltip } from "flowbite-react";

const floors = [
  { code: "4f", name: "4/F", color: "#ab8d5e" },
  { code: "3f", name: "3/F", color: "#1673c0" },
  { code: "2f", name: "2/F", color: "#e33544" },
  { code: "1f", name: "1/F", color: "#e33544" },
  { code: "gf", name: "G/F", color: "#209e70" },
  { code: "lpf", name: "LP/F", color: "#e33544" },
];

export default function Home() {
  const { spaces } = useSpacesStore();

  return (
    <Layout>
      <div className="container mx-auto">
        <div className="lg:py-5 lg:px-0 py-4 px-4">
          <h1 className="font-bold text-lg mb-4">Please select a space:</h1>

          <div className="lg:space-y-16 space-y-10">
            {floors.map((floor) => {
              const spacesInFloor = spaces.filter((space) => space.floor.code === floor.code);
              if (spacesInFloor.length === 0) {
                return null;
              }
              return (
                <div key={floor.code} className="lg:flex lg:space-x-2 mb-4">
                  <div className="lg:text-center lg:w-32 lg:pt-4 lg:mb-0 mb-2">
                    <span
                      className="lg:text-4xl lg:font-medium text-lg font-bold"
                      style={{ color: floor.color }}
                    >
                      {floor.name}
                    </span>
                  </div>
                  <div className="lg:flex-1 grid lg:grid-cols-4 grid-cols-2 lg:gap-4 gap-3">
                    {spacesInFloor.map((space) => (
                      <div
                        key={space.id}
                        className="flex flex-col items-center lg:space-y-4 space-y-2 bg-gray-100 rounded px-4 py-4"
                      >
                        <Link
                          to={`/spaces/${space.id}`}
                          className="text-center lg:text-lg font-bold"
                        >
                          <img
                            src={space.thumbnail}
                            alt=""
                            className="h-24 mx-auto mb-4"
                          />
                          <p>
                            <span>{space.name}</span>
                            {space.min_users > 1 && (
                              <Tooltip
                                theme={{ target: "w-fit inline-block" }}
                                content="Multiple users check-in required"
                              >
                                <svg
                                  className="w-4 h-4 inline-block ml-1 text-gray-500"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="1.5"
                                  viewBox="0 0 24 24"
                                  xmlns="http://www.w3.org/2000/svg"
                                  aria-hidden="true"
                                >
                                  <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
                                  ></path>
                                </svg>
                              </Tooltip>
                            )}
                          </p>
                        </Link>
                        <p className="text-center text-gray-500 text-sm">
                          {space.restrictions}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </Layout>
  );
}
